import * as cTypes from 'config/ConfigTypes';

export const checkRentItemFilter = ({ el }) => {
    let itemFilter = cTypes.RENTAL_ITEMFILTER_OBJ;
    let newArr;
    if (el && el.metadata && el.metadata.fields
        && el.metadata.fields[itemFilter.field]) {
        let fieldValue = el.metadata.fields[itemFilter.field];
        try {
            newArr = JSON.parse(fieldValue);
            let isExists = false;
            if (newArr && newArr.length) {
                newArr.forEach(entry => {
                    if (itemFilter.value.split(";").some(v => v == entry)) {
                        isExists = true;
                    }
                });
                if (isExists) return true;
            }
            return false;

        } catch (err) { console.log("LOGS: checkRentalItemFiler error", err); }

    }
    return false;
}
